var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":"Lead löschen","action":"delete","on-submit":_vm.submit,"on-close":_vm.close}},[_c('div',{staticClass:"mb-2"},[_vm._v(" Soll der Lead wirklich gelöscht werden? ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }